import {Component, Input, OnInit} from '@angular/core';
import {HtmlUtilsService} from "../../../../html-utils/html-utils.service";

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss']
})
export class LogoComponent implements OnInit {
  highContrast: boolean;

  constructor(private htmlUtils: HtmlUtilsService) {
    this.highContrast = this.htmlUtils.contrast;
    this.htmlUtils.highContrast.subscribe((value) => {
      if (value !== this.highContrast) {
        this.highContrast = value;
      }
    });
  }

  _src: string;

  _wcgaSrc: string;

  ngOnInit() {
  }

  @Input() alternativeText: string;

  @Input() logoClass: string = "logo";

  @Input()
  set src(value: string){
    this._src = value;
  }

  @Input()
  set wcgaSrc(value: string){
    this._wcgaSrc = value;
  }

}
